import {  selectUser, unsetAuthData } from 'app/slice/authSlice';

import store from 'app/store';
import React, { useEffect, useState, useRef, useContext } from 'react';
import { CSSTransition } from 'react-transition-group';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { notification } from 'constants/notification';
import { useApp } from 'context/AppContext';
import { Badge } from 'primereact/badge';
import { routerMain } from 'constants/routerMain';
import { Link } from 'react-router-dom';
import { Button } from 'primereact/button';
import ReactHtmlParser from 'react-html-parser';
import avatarImg from 'assets/images/avatar.png';
import 'moment/locale/vi';

import { Avatar } from 'primereact/avatar';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Dropdown } from 'primereact/dropdown';
import Flags from 'country-flag-icons/react/3x2';
import { BlockUI } from 'primereact/blockui';
import { Tag } from 'primereact/tag';
import { useKeycloak } from '@react-keycloak/web';
import notifyApi from 'api/notifyApi';
import { AppTranslationsContext } from 'context/AppTranslationsContext';
import {  EN_LANG, VI_LANG } from 'constants/global';

const MenubarRight = (props) => {
    const { className, dataSocket } = props;
    const contextLang = useContext(AppTranslationsContext);
    const { showAlert } = useApp();
    const intl = useIntl();
    const userPer = useSelector(selectUser);
    const [loading1, setLoading1] = useState(false);
    const [loading, setLoading] = useState(false);
    const [listNotify, setListNotify] = useState([]);
    const [countNotify, setCountNotify] = useState(0);
    const [packageType, setPackageType] = useState(null);
    const emptyDataSearch = {
        row: 10,
    };
    const [dataSearch, setDataSearch] = useState(emptyDataSearch);
    const [blockedNotify, setBlockedNotify] = useState(false);

    const moreActionRef = useRef(null);
    const moreActionItemRef = useRef(null);
    const langSelectItems = [
        {
            label: (
                <>
                    <Flags.VN title="Tiếng Việt" width="1rem" />
                    &nbsp;Tiếng Việt
                </>
            ),
            value: VI_LANG,
        },
        {
            label: (
                <>
                    <Flags.US title="English" width="1rem" />
                    &nbsp;English
                </>
            ),
            value: EN_LANG,
        },
    ];

    const { keycloak } = useKeycloak();

    const Logout = () => {
        store.dispatch(unsetAuthData());
        keycloak.logout();
        return;
    };

    //     1. Yêu cầu trình ký
    // 2. Thông báo hướng dẫn sử dụng mới
    // 3. Thông báo nâng cấp email
    // 4: Yêu cầu hợp đồng
    // 5: Nhắc đổi mật khẩu
    // 6: Đối tác
    // 7: Tài liệu
    // 8: Yêu cầu hồ sơ hợp đồng

    const listIconNotify = [
        { code: 1, icon: 'pi-send', color: 'text-info' },
        { code: 2, icon: 'pi-book', color: 'text-secondary' },
        { code: 3, icon: 'pi-envelope', color: 'text-success' },
        { code: 4, icon: 'pi-send', color: 'text-warning' },
        { code: 5, icon: 'pi-exclamation-triangle', color: 'text-danger' },
        { code: 6, icon: 'pi-briefcase', color: 'text-info' },
        { code: 7, icon: 'pi-file', color: 'text-secondary' },
        { code: 8, icon: 'pi-file', color: 'text-warning' },
    ];
    const fetDataNotify = async () => {
        setLoading1(true);
        setBlockedNotify(true);
        console.log('render');
        try {
            let result = await notifyApi.getFilter(dataSearch);
            if (result) {
                const { status, message, data } = result;
                if (status === 1) {
                    let newData = data?.data.map((e) => {
                        let iconRow = listIconNotify.filter((eR) => eR.code === e.type)[0];
                        let timeText = '';

                        if (contextLang.locale === VI_LANG) {
                            moment.locale(VI_LANG);
                            timeText = moment(e.created_at).fromNow();
                        } else {
                            moment.locale(EN_LANG);
                            timeText = moment(e.created_at).fromNow();
                        }
                        e.icon = iconRow?.icon ?? 'pi-envelope';
                        e.color = iconRow?.color ?? 'text-success';
                        e.time = timeText;
                        return e;
                    });
                    setListNotify(newData);
                    setCountNotify(result.count);
                    setBlockedNotify(false);
                    setLoading1(false);
                }
                if (status === 2) {
                    setBlockedNotify(false);
                    setLoading1(false);
                    showAlert('error', notification.FAIL, message);
                }
            }
        } catch (error) {
            console.error('error: ', error);
            setBlockedNotify(false);
            setLoading1(false);
        }
    };
    const handlePackage = () => {
        if (userPer)
            switch (userPer.package_group) {
                case 1:
                    setPackageType('Registered Free');
                    break;
                case 2:
                    setPackageType('Starter');
                    break;
                case 3:
                    setPackageType('Basic');
                    break;
                case 4:
                    setPackageType('Advance');
                    break;
                case 5:
                    setPackageType('Premium');
                    break;
                default:
                    setPackageType('');
            }
    };
    const fetDataNotifyNotLoading = async () => {
        try {
            let result = await notifyApi.getFilter(dataSearch);
            if (result) {
                const { status, message, data } = result;
                if (status === 1) {
                    let newData = data.data.map((e) => {
                        let iconRow = listIconNotify.filter((eR) => eR.code === e.type)[0];
                        let timeText = '';

                        if (contextLang.locale === VI_LANG) {
                            moment.locale(VI_LANG);
                            timeText = moment(e.created_at).fromNow();
                        } else {
                            moment.locale(EN_LANG);
                            timeText = moment(e.created_at).fromNow();
                        }
                        e.icon = iconRow.icon ?? 'pi-envelope';
                        e.color = iconRow.color ?? 'text-success';
                        e.time = timeText;
                        return e;
                    });
                    setListNotify(newData);
                    setCountNotify(result.count);
                }
                if (status === 2) {
                    showAlert('error', notification.FAIL, message);
                }
            }
        } catch (error) {
            console.error('error: ', error);
        }
    };

    useEffect(() => {
        handlePackage();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        fetDataNotify();
        // eslint-disable-next-line
    }, [dataSocket, contextLang.locale,dataSearch]);

    const handelRefresh = async (e) => {
        try {
            e.preventDefault();
            fetDataNotify();
        } catch (error) {
            console.error('error: ', error);
        }
    };

    const onViewMoreClick = async (e) => {
        try {
            e.preventDefault();
            let rowPage = dataSearch?.row + 10;
            setDataSearch({
                row: rowPage,
            });
        } catch (error) {
            console.error('error: ', error);
        }
    };
    const onClickMoreActionMenu = (event) => {
        try {
            let buttonView = document.querySelector(`.menu-notify__ul-action--more`);
            buttonView.classList.toggle('p-d-flex');
        } catch (error) {
            console.error('error: ', error);
        }
    };
    const onClickMoreActionItem = (event, data) => {
        try {
            let buttonView = document.querySelector(`.menu-notify__action--more${data.uuid}`);
            buttonView.classList.toggle('p-d-flex');
        } catch (error) {
            console.error('error: ', error);
        }
    };
    const onMoseEnterRowNotify = (event, data, index) => {
        let buttonView = document.querySelector(`.menu-notify__item--more${data.uuid}`);
        buttonView.classList.add('p-d-flex');
    };
    const onMoseLeaveRowNotify = (event, data, index) => {
        let buttonView = document.querySelector(`.menu-notify__item--more${data.uuid}`);
        buttonView.classList.remove('p-d-flex');
    };
    const onMoseEnterActionItem = (event, data, index) => {
        let buttonView = document.querySelector(`.menu-notify__item--more${data.uuid}`);
        buttonView.classList.toggle('p-d-flex');
    };

    // call api
    const handleClickReadAll = async () => {
        try {
            setLoading(true);
            let uuidUser = { uuid: userPer?.data.uuid };
            let buttonView = document.querySelector(`.menu-notify__ul--more`);
            buttonView.click();
            let result = await notifyApi.readAll(uuidUser);
            if (result) {
                const { status, message } = result;
                if (status === 1) {
                    fetDataNotify();
                    setActiveMenuIndex(1);
                    setLoading(false);
                }
                if (status === 2) {
                    setLoading(false);
                    showAlert('error', notification.NOTIFY_READ, message);
                }
            }
        } catch (error) {
            console.error('error: ', error);
            setLoading(false);
            showAlert('error', notification.NOTIFY_READ, notification.MESSAGE_ERROR);
        }
    };
    const handleClickDeleteAll = async () => {
        setLoading(true);
        try {
            let uuidUser = { uuid: userPer?.data.uuid };
            let buttonView = document.querySelector(`.menu-notify__ul--more`);
            if (buttonView) buttonView.click();
            let result = await notifyApi.deleteAll(uuidUser);
            if (result) {
                const { status, message } = result;
                if (status === 1) {
                    setLoading(false);
                    setListNotify([]);
                    setCountNotify(0);
                }
                if (status === 2) {
                    setLoading(false);
                    showAlert('error', notification.NOTIFY_DELETE, message);
                }
            }
        } catch (error) {
            console.error('error: ', error);
            setLoading(false);
            showAlert('error', notification.NOTIFY_DELETE, notification.MESSAGE_ERROR);
        }
    };
    const handleClickReadOne = async (statusView, notifyItem) => {
        setBlockedNotify(true);
        try {
            let idNotify = {
                uuid: notifyItem.uuid,
                is_view: statusView,
            };
            let buttonView = document.querySelector(`.menu-notify__item--more${notifyItem.uuid}`);
            if (buttonView) buttonView.click();
            let result = await notifyApi.readOne(idNotify);
            if (result) {
                const { data, status, message } = result;
                if (status === 1) {
                    let newListNotify = listNotify.map((e) => {
                        if (e.uuid === data.uuid) {
                            e.is_view = Number(data.is_view);
                        }
                        return e;
                    });
                    setListNotify(newListNotify);
                    fetDataNotifyNotLoading();
                    setBlockedNotify(false);
                }
                if (status === 2) {
                    setBlockedNotify(false);
                    showAlert('error', notification.NOTIFY_READ, message);
                }
            }
        } catch (error) {
            console.error('error: ', error);
            setBlockedNotify(false);
            showAlert('error', notification.NOTIFY_READ, notification.MESSAGE_ERROR);
        }
    };

    const handleClickDeleteOne = async (notifyItem) => {
        setBlockedNotify(true);
        try {
            let uuidNotify = { uuid: notifyItem.uuid };
            let buttonView = document.querySelector(`.menu-notify__item--more${notifyItem.uuid}`);
            if (buttonView) buttonView.click();
            let result = await notifyApi.delete(uuidNotify);
            if (result) {
                const { status, message } = result;
                if (status === 1) {
                    let liView = document.querySelector(`.menu-notify__li-${notifyItem.uuid}`);
                    liView.classList.add('removed');
                    liView.addEventListener('animationend', () => {
                        liView.classList.add('p-d-none');
                    });
                    fetDataNotifyNotLoading();
                    setBlockedNotify(false);
                }
                if (status === 2) {
                    setBlockedNotify(false);
                    showAlert('error', notification.NOTIFY_DELETE, message);
                }
            }
        } catch (error) {
            console.error('error: ', error);
            setBlockedNotify(false);
            showAlert('error', notification.NOTIFY_DELETE, notification.MESSAGE_ERROR);
        }
    };
    const handelOnLinkToNotify = async (event, notifyItem, index) => {
        try {
            let idNotify = {
                uuid: notifyItem.uuid,
                is_view: 2,
            };
            let result = await notifyApi.readOne(idNotify);
            if (result) {
                const { status, message } = result;
                if (status === 1) {
                    fetDataNotifyNotLoading();
                    setActiveMenuIndex(null);
                }
                if (status === 2) {
                    showAlert('error', notification.NOTIFY_READ, message);
                }
            }
        } catch (error) {
            console.error('error: ', error);
            showAlert('error', notification.NOTIFY_READ, notification.MESSAGE_ERROR);
        }
    };

    const topBarMenuRef = useRef(null);
    const userOverlayRef = useRef(null);
    const notifyOverlayRef = useRef(null);
    const [activeMenuIndex, setActiveMenuIndex] = useState(null);

    const resetMenuActive = () => {
        setActiveMenuIndex(null);
    };

    const toggleMenu = (event, index) => {
        setActiveMenuIndex((prevState) => (prevState === index ? null : index));
        event.preventDefault();
    };
    function onMenuEnter() {
        bindOutsideClickListener();
    }
    function outsideClickListener(event) {
        if (activeMenuIndex != null && isOutsideTopbarMenuClicked(event)) {
            unbindOutsideClickListener();
        }
    }
    function bindOutsideClickListener() {
        document.addEventListener('click', outsideClickListener);
    }

    function unbindOutsideClickListener() {
        if (outsideClickListener) {
            document.removeEventListener('click', outsideClickListener);
            resetMenuActive();
        }
    }
    function isOutsideTopbarMenuClicked(event) {
        try {
            if (topBarMenuRef && event)
                return !(
                    topBarMenuRef.current?.isSameNode(event.target) || topBarMenuRef.current?.contains(event.target)
                );
        } catch (error) {
            console.error('error: ', error);
        }
    }
    const countryOptionTemplate = (option) => {
        return (
            <div className="country-item">
                <div className="p-d-flex">{option.label}</div>
            </div>
        );
    };

    return (
        <div className={`MenubarRight ${className ? className : ''}`}>
            <ul ref={topBarMenuRef} className="topbar-menu p-menubar p-unselectable-text" role="menubar">
                <li role="none" className="p-menuitem">
                    <Dropdown
                        options={langSelectItems}
                        onChange={(e) => contextLang.selectLanguage(e.value)}
                        placeholder={
                            contextLang.locale === 'vi' ? (
                                <Flags.VN title="Tiếng Việt" width="20" />
                            ) : (
                                <Flags.US title="English" width="20" />
                            )
                        }
                        style={{
                            background: 'transparent',
                            border: 'none',
                        }}
                        itemTemplate={countryOptionTemplate}
                        className="flag-icon"
                    />
                </li>
                <li role="none" className="topbar-submenu p-menuitem menu-notify p-mx-2">
                    <div
                        type="button"
                        role="menuitem"
                        onClick={(e) => toggleMenu(e, 1)}
                        aria-haspopup
                        className="pointer menu-link"
                    >
                        <i className="pi pi-bell p-overlay-badge icon-notify font-size-21 " title="Thông báo">
                            {!loading1 && countNotify > 0 && <Badge value={countNotify}></Badge>}
                        </i>
                    </div>
                    <CSSTransition
                        nodeRef={notifyOverlayRef}
                        classNames="p-connected-overlay"
                        timeout={{ enter: 120, exit: 100 }}
                        in={activeMenuIndex === 1}
                        unmountOnExit
                        onEntered={onMenuEnter}
                    >
                        <ul
                            ref={notifyOverlayRef}
                            className="p-submenu-list menu-notify__ul w--100"
                            role="menu"
                            aria-label="Notify"
                            //  onMouseLeave={(event) => onMoseLeaveMenuNotify(event)}
                        >
                            <BlockUI blocked={blockedNotify}>
                                <h5 className="p-ml-2">
                                    <span className="p-ml-2 ">{intl.formatMessage({ id: 'notify' })}</span>
                                    <Button
                                        icon="pi pi-ellipsis-h"
                                        title={intl.formatMessage({ id: 'Notify.action' })}
                                        className={`p-button-text p-button-secondary
                   menu-notify__ul--more absolute p-button-lg ${listNotify.length > 0 ? 'p-d-flex' : 'p-d-none'}`}
                                        onClick={(event) => onClickMoreActionMenu(event)}
                                        type="button"
                                        aria-haspopup
                                        aria-controls="overlay_menu"
                                    />
                                    <div
                                        ref={moreActionRef}
                                        className={`menu-notify__ul-action--more p-d-none
                                                    p-tieredmenu p-component p-tieredmenu-overlay
                                                    p-connected-overlay-enter-done
                                                    menuUlMore`}
                                    >
                                        <ul className="" role="menubar" aria-orientation="horizontal">
                                            <li className="p-menuitem" role="none" onClick={handelRefresh}>
                                                <span className="p-menuitem-link" role="menuitem" aria-haspopup="false">
                                                    <span className="p-menuitem-icon pi pi-fw pi-refresh"></span>
                                                    <span className="p-menuitem-text">
                                                        {intl.formatMessage({ id: 'refresh' })}
                                                    </span>
                                                </span>
                                            </li>
                                            <li className="p-menuitem" role="none" onClick={() => handleClickReadAll()}>
                                                <span className="p-menuitem-link" role="menuitem" aria-haspopup="false">
                                                    <span className="p-menuitem-icon pi pi-fw pi-check"></span>
                                                    <span className="p-menuitem-text">
                                                        {intl.formatMessage({ id: 'mark-all-read' })}
                                                    </span>
                                                </span>
                                            </li>
                                            <li
                                                className="p-menuitem "
                                                role="none"
                                                onClick={() => handleClickDeleteAll()}
                                            >
                                                <span className="p-menuitem-link" role="menuitem" aria-haspopup="false">
                                                    <span className="p-menuitem-icon pi pi-fw pi-times-circle"></span>
                                                    <span className="p-menuitem-text">
                                                        {intl.formatMessage({ id: 'remove-all-noti' })}
                                                    </span>
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </h5>
                                {/* <hr /> */}
                                <div className={`custombar1 ${!loading1 ? 'p-d-block' : 'p-d-none'}`}>
                                    {loading && (
                                        <Button loading={loading} className="p-button-text p-button-lg w--100" />
                                    )}
                                    {!loading &&
                                        listNotify.map((notifyItem, index) => (
                                            <li
                                                role="none"
                                                key={`${index}${notifyItem.uuid}`}
                                                className={`menu-notify__li ${
                                                    notifyItem.is_view === 2 ? 'menu-notify__li--active' : ''
                                                }
                            menu-notify__li-${notifyItem.uuid}
                            `}
                                            >
                                                <Link
                                                    role="menuitem"
                                                    to={`${notifyItem.link}`}
                                                    className="p-menuitem-link"
                                                    aria-haspopup="false"
                                                    onClick={(event) => handelOnLinkToNotify(event, notifyItem)}
                                                    onMouseEnter={(event) => onMoseEnterRowNotify(event, notifyItem)}
                                                    onMouseLeave={(event) => onMoseLeaveRowNotify(event, notifyItem)}
                                                >
                                                    <span className="relative">
                                                        <img
                                                            src={avatarImg}
                                                            className="menu-notify__li--avatar"
                                                            alt="avatar notify"
                                                            loading="lazy"
                                                            width="30"
                                                            height="30"
                                                        />
                                                        <i
                                                            className={`menu-notify__li--icon pi ${notifyItem.icon} ${notifyItem.color}`}
                                                        ></i>
                                                    </span>
                                                    <div className="menu-notify__item p-ml-3">
                                                        <div className="menu-notify__text max-line-3">
                                                            {ReactHtmlParser(notifyItem.title)}
                                                        </div>
                                                        <div
                                                            className={`menu-notify__date ${
                                                                notifyItem.is_view === 2
                                                                    ? 'menu-notify__date--active'
                                                                    : ''
                                                            }`}
                                                        >
                                                            {notifyItem.time}
                                                        </div>
                                                    </div>
                                                </Link>
                                                <Button
                                                    icon="pi pi-ellipsis-h"
                                                    title={intl.formatMessage({ id: 'Notify.action' })}
                                                    className={`
                                                p-d-none
                                                p-button-rounded p-button-secondary absolute
                                                menu-notify__item--more  menu-notify__item--more${notifyItem.uuid}`}
                                                    onClick={(event) => onClickMoreActionItem(event, notifyItem)}
                                                    onMouseEnter={(event) => onMoseEnterActionItem(event, notifyItem)}
                                                />
                                                <div
                                                    className={`
                                                 menu-notify__action--more${notifyItem.uuid}
                                                    p-d-none
                                                    p-tieredmenu p-component p-tieredmenu-overlay
                                                    p-connected-overlay-enter-done
                                                    menuSeeMore
                                                `}
                                                >
                                                    <ul
                                                        role="menubar"
                                                        aria-orientation="horizontal"
                                                        ref={moreActionItemRef}
                                                    >
                                                        {notifyItem.is_view === 2 ? (
                                                            <li
                                                                className="p-menuitem"
                                                                role="none"
                                                                onClick={() => handleClickReadOne(1, notifyItem)}
                                                            >
                                                                <span
                                                                    className="p-menuitem-link"
                                                                    role="menuitem"
                                                                    aria-haspopup="false"
                                                                >
                                                                    <span className="p-menuitem-icon pi pi-fw pi-check"></span>
                                                                    <span className="p-menuitem-text">
                                                                        {intl.formatMessage({ id: 'mark-unread' })}
                                                                    </span>
                                                                </span>
                                                            </li>
                                                        ) : (
                                                            <li
                                                                className="p-menuitem"
                                                                role="none"
                                                                onClick={() => handleClickReadOne(2, notifyItem)}
                                                            >
                                                                <span
                                                                    className="p-menuitem-link"
                                                                    role="menuitem"
                                                                    aria-haspopup="false"
                                                                >
                                                                    <span className="p-menuitem-icon pi pi-fw pi-check"></span>
                                                                    <span className="p-menuitem-text">
                                                                        {intl.formatMessage({ id: 'mark-read' })}
                                                                    </span>
                                                                </span>
                                                            </li>
                                                        )}
                                                        <li
                                                            className="p-menuitem "
                                                            role="none"
                                                            onClick={() => handleClickDeleteOne(notifyItem)}
                                                        >
                                                            <span
                                                                className="p-menuitem-link"
                                                                role="menuitem"
                                                                aria-haspopup="false"
                                                            >
                                                                <span className="p-menuitem-icon pi pi-fw pi-times-circle"></span>
                                                                <span className="p-menuitem-text">
                                                                    {intl.formatMessage({ id: 'remove-noti' })}
                                                                </span>
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </li>
                                        ))}
                                </div>

                                <div className="p-text-center p-mb-2">
                                    {loading1 && <Button loading={loading1} className="p-button-text p-button-lg" />}
                                </div>
                                {listNotify.length === 0 && (
                                    <li role="none" className={`menu-notify__li `}>
                                        <div className="p-text-center text-primary p-py-3">
                                            <span>{intl.formatMessage({ id: 'no-noti' })}</span>
                                        </div>
                                    </li>
                                )}
                                <div className="p-text-center">
                                    {listNotify.length > 0 && (
                                        <Button
                                            label={intl.formatMessage({ id: 'see-more' })}
                                            className="p-button-text menu-notify__button"
                                            // iconPos="right"
                                            onClick={(event) => onViewMoreClick(event)}
                                        />
                                    )}
                                </div>
                            </BlockUI>
                        </ul>
                    </CSSTransition>
                </li>

                <li role="none" className="p-menuitem">
                    <div
                        type="button"
                        role="menuitem"
                        onClick={(e) => toggleMenu(e, 2)}
                        aria-haspopup
                        className="p-menuitem-link menu-link"
                    >
                        <div className="user_info">
                            <div className="p-menuitem-text menu-text p-mr-2 text-right">
                                {userPer ? userPer.data.fullname : ''}
                            </div>
                            <div className="text-right">
                                {packageType && <Tag className="p-mr-2" value={packageType}></Tag>}
                            </div>
                        </div>
                        <Avatar icon="pi pi-user" shape="circle" />
                    </div>
                    <CSSTransition
                        nodeRef={userOverlayRef}
                        classNames="p-connected-overlay"
                        timeout={{ enter: 120, exit: 100 }}
                        in={activeMenuIndex === 2}
                        unmountOnExit
                        onEntered={onMenuEnter}
                    >
                        <ul ref={userOverlayRef} aria-label="User" className="p-submenu-list w--100" role="menu">
                            <li className="user_info-mobile">
                                <div className="p-menuitem-text menu-text p-mr-2">
                                    {userPer ? userPer.data.fullname : ''}
                                </div>
                                <div>{packageType && <Tag className="p-mr-2" value={packageType}></Tag>}</div>
                            </li>
                            <li role="none">
                                <Link
                                    role="menuitem"
                                    to={routerMain.CHANGE_ORGANIZATION}
                                    aria-haspopup="false"
                                    className="p-menuitem-link"
                                >
                                    <span className="p-menuitem-icon pi pi-fw pi-refresh"></span>
                                    <span className="p-menuitem-text">
                                        {intl.formatMessage({ id: 'switch-organization' })}
                                    </span>
                                </Link>
                            </li>
                            <li role="none">
                                <Link
                                    role="menuitem"
                                    to={routerMain.PROFILE}
                                    aria-haspopup="false"
                                    className="p-menuitem-link"
                                >
                                    <span className="p-menuitem-icon pi pi-fw pi-user-edit"></span>
                                    <span className="p-menuitem-text">
                                        {intl.formatMessage({ id: 'account-manage' })}
                                    </span>
                                </Link>
                            </li>
                            {/* {authData?.app === APP_ECONTRACT && (
                                <li role="none">
                                    <Link
                                        role="menuitem"
                                        to={routerMain.SERVICE_MANAGER}
                                        aria-haspopup="false"
                                        className="p-menuitem-link"
                                    >
                                        <span className="p-menuitem-icon pi pi-fw pi-box"></span>
                                        <span className="p-menuitem-text">
                                            {intl.formatMessage({ id: 'common.serviceManagement' })}
                                        </span>
                                    </Link>
                                </li>
                            )} */}
                            <li role="none">
                                <Link
                                    to="/"
                                    role="menuitem"
                                    aria-haspopup="false"
                                    onClick={Logout}
                                    className="p-menuitem-link"
                                >
                                    <span className="p-menuitem-icon pi pi-fw pi-power-off"></span>
                                    <span className="p-menuitem-text">{intl.formatMessage({ id: 'logout' })}</span>
                                </Link>
                            </li>
                        </ul>
                    </CSSTransition>
                </li>
            </ul>
        </div>
    );
};

export default MenubarRight;

MenubarRight.propTypes = {
    className: PropTypes.string,
};

MenubarRight.defaultProps = {};
